/**
 * @fileoverview Agent definition for story-feedback-v1.
 *
 * Multi-perspective editorial feedback from three distinct personas:
 *  - Yellow press critic (roast)
 *  - Developmental editor (craft)
 *  - Publisher (audience / market fit)
 *
 * Takes only the concatenated written story as input — no plan or snapshot
 * data — and reacts to the prose the way a reader/critic would.
 *
 * Results are persisted on the project (storyStructure.lastStoryFeedback)
 * so the user can reopen the last run from the Story Analysis card.
 *
 * @category narrative.story.analysis
 * @type primitive
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas';
import { InputSchema, OutputSchema } from './schema';
import { prompt } from './prompt';

// =============================================================================
// AGENT DEFINITION
// =============================================================================

export const definition: AppAgentDefinition = {
  id: 'story-feedback-v1',
  kind: 'primitive',
  name: 'Story Feedback',
  description: 'Generates multi-perspective editorial feedback on the full written story from three personas: a yellow press critic, a developmental editor, and a publisher.',
  category: 'structure',
  defaultPrompt: prompt,
  inputSchema: InputSchema,
  outputSchema: OutputSchema,

  // --- Metadata (Hybrid Architecture) ---
  metadata: {
    status: 'active',
    type: 'primitive',
    addedIn: '2026-04',
    lastUpdated: '2026-04',
    taxonomyPath: 'narrative.story.analysis',
    usedBy: [
      'primitives/use-story-feedback-v1.ts',
    ],
    usedInComposites: [],
    relatedAgents: [
      'divergence-report-v2',
    ],
  },
};
